/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Infra API Specification
 * OpenAPI spec version: 0.0.7
 */
import { useQuery } from '@tanstack/vue-query';
import type {
  DataTag,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryReturnType,
} from '@tanstack/vue-query';

import { computed, unref } from 'vue';
import type { MaybeRef } from 'vue';

import type {
  ApiResponseInfraGpuByTargetResponse,
  ApiResponseInfraGpuInfoResponse,
  ApiResponseInfraGpuMigInfoResponse,
  ApiResponseInfraGpuNamespaceResponse,
  ApiResponseInfraGpuProcessResponse,
  ApiResponseInfraGpuResourceMapResponse,
  ApiResponseInfraGpuResponse,
  ApiResponseInfraGpuTargetResponse,
  ApiResponseString,
  GetV11InfraGpuInfoParams,
  GetV11InfraGpuListParams,
  GetV11InfraGpuMigInfoParams,
  GetV11InfraGpuModelsParams,
  GetV11InfraGpuNamespacesParams,
  GetV11InfraGpuProcessParams,
  GetV11InfraGpuResourceParams,
  GetV11InfraGpuTargetsParams,
} from '../../model';

import { customAxiosInstance } from '../../../../common/api/utils/mutator';
import type { ErrorType } from '../../../../common/api/utils/mutator';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * GPU/MIG 디바이스가 존재하는 클러스터 ID 목록 조회
 * @summary GPU 보유 클러스터 목록
 */
export const getV11InfraGpuClusters = (
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  return customAxiosInstance<ApiResponseString>(
    { url: `/api/v11/infra/gpu/clusters`, method: 'GET', signal },
    options,
  );
};

export const getGetV11InfraGpuClustersQueryKey = () => {
  return ['api', 'v11', 'infra', 'gpu', 'clusters'] as const;
};

export const getGetV11InfraGpuClustersQueryOptions = <
  TData = Awaited<ReturnType<typeof getV11InfraGpuClusters>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getV11InfraGpuClusters>>, TError, TData>
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV11InfraGpuClustersQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV11InfraGpuClusters>>> = ({ signal }) =>
    getV11InfraGpuClusters(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV11InfraGpuClusters>>,
    TError,
    TData
  >;
};

export type GetV11InfraGpuClustersQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV11InfraGpuClusters>>
>;
export type GetV11InfraGpuClustersQueryError = ErrorType<unknown>;

/**
 * @summary GPU 보유 클러스터 목록
 */

export function useGetV11InfraGpuClusters<
  TData = Awaited<ReturnType<typeof getV11InfraGpuClusters>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV11InfraGpuClusters>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV11InfraGpuClustersQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * GPU 메타데이터, 현재 스냅샷, MIG 정보 조회
 * @summary GPU 상세 정보
 */
export const getV11InfraGpuInfo = (
  params: MaybeRef<GetV11InfraGpuInfoParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<ApiResponseInfraGpuInfoResponse>(
    { url: `/api/v11/infra/gpu/info`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getGetV11InfraGpuInfoQueryKey = (params?: MaybeRef<GetV11InfraGpuInfoParams>) => {
  return ['api', 'v11', 'infra', 'gpu', 'info', ...(params ? [params] : [])] as const;
};

export const getGetV11InfraGpuInfoQueryOptions = <
  TData = Awaited<ReturnType<typeof getV11InfraGpuInfo>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV11InfraGpuInfoParams>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getV11InfraGpuInfo>>, TError, TData>>;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV11InfraGpuInfoQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV11InfraGpuInfo>>> = ({ signal }) =>
    getV11InfraGpuInfo(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV11InfraGpuInfo>>,
    TError,
    TData
  >;
};

export type GetV11InfraGpuInfoQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV11InfraGpuInfo>>
>;
export type GetV11InfraGpuInfoQueryError = ErrorType<unknown>;

/**
 * @summary GPU 상세 정보
 */

export function useGetV11InfraGpuInfo<
  TData = Awaited<ReturnType<typeof getV11InfraGpuInfo>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV11InfraGpuInfoParams>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getV11InfraGpuInfo>>, TError, TData>>;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV11InfraGpuInfoQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * 클러스터/호스트 그룹 기준 GPU 목록 조회
 * @summary GPU 기본뷰 목록
 */
export const getV11InfraGpuList = (
  params?: MaybeRef<GetV11InfraGpuListParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<ApiResponseInfraGpuResponse>(
    { url: `/api/v11/infra/gpu/list`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getGetV11InfraGpuListQueryKey = (params?: MaybeRef<GetV11InfraGpuListParams>) => {
  return ['api', 'v11', 'infra', 'gpu', 'list', ...(params ? [params] : [])] as const;
};

export const getGetV11InfraGpuListQueryOptions = <
  TData = Awaited<ReturnType<typeof getV11InfraGpuList>>,
  TError = ErrorType<unknown>,
>(
  params?: MaybeRef<GetV11InfraGpuListParams>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getV11InfraGpuList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV11InfraGpuListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV11InfraGpuList>>> = ({ signal }) =>
    getV11InfraGpuList(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV11InfraGpuList>>,
    TError,
    TData
  >;
};

export type GetV11InfraGpuListQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV11InfraGpuList>>
>;
export type GetV11InfraGpuListQueryError = ErrorType<unknown>;

/**
 * @summary GPU 기본뷰 목록
 */

export function useGetV11InfraGpuList<
  TData = Awaited<ReturnType<typeof getV11InfraGpuList>>,
  TError = ErrorType<unknown>,
>(
  params?: MaybeRef<GetV11InfraGpuListParams>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getV11InfraGpuList>>, TError, TData>>;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV11InfraGpuListQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * GPU UUID 또는 MIG UUID로 GPU-MIG 매핑 목록 조회
 * @summary GPU-MIG 매핑 조회
 */
export const getV11InfraGpuMigInfo = (
  params?: MaybeRef<GetV11InfraGpuMigInfoParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<ApiResponseInfraGpuMigInfoResponse>(
    { url: `/api/v11/infra/gpu/mig-info`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getGetV11InfraGpuMigInfoQueryKey = (
  params?: MaybeRef<GetV11InfraGpuMigInfoParams>,
) => {
  return ['api', 'v11', 'infra', 'gpu', 'mig-info', ...(params ? [params] : [])] as const;
};

export const getGetV11InfraGpuMigInfoQueryOptions = <
  TData = Awaited<ReturnType<typeof getV11InfraGpuMigInfo>>,
  TError = ErrorType<unknown>,
>(
  params?: MaybeRef<GetV11InfraGpuMigInfoParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV11InfraGpuMigInfo>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV11InfraGpuMigInfoQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV11InfraGpuMigInfo>>> = ({ signal }) =>
    getV11InfraGpuMigInfo(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV11InfraGpuMigInfo>>,
    TError,
    TData
  >;
};

export type GetV11InfraGpuMigInfoQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV11InfraGpuMigInfo>>
>;
export type GetV11InfraGpuMigInfoQueryError = ErrorType<unknown>;

/**
 * @summary GPU-MIG 매핑 조회
 */

export function useGetV11InfraGpuMigInfo<
  TData = Awaited<ReturnType<typeof getV11InfraGpuMigInfo>>,
  TError = ErrorType<unknown>,
>(
  params?: MaybeRef<GetV11InfraGpuMigInfoParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV11InfraGpuMigInfo>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV11InfraGpuMigInfoQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}
/**
 * GPU Model 목록 조회. scope 를 주면 해당 환경(호스트/쿠버네티스 노드)에 붙은 GPU 모델만 반환하고, 생략하면 전체를 반환한다.
 * @summary GPU 모델명 목록
 */
export const getV11InfraGpuModels = (
  params?: MaybeRef<GetV11InfraGpuModelsParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<ApiResponseString>(
    { url: `/api/v11/infra/gpu/models`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getGetV11InfraGpuModelsQueryKey = (params?: MaybeRef<GetV11InfraGpuModelsParams>) => {
  return ['api', 'v11', 'infra', 'gpu', 'models', ...(params ? [params] : [])] as const;
};

export const getGetV11InfraGpuModelsQueryOptions = <
  TData = Awaited<ReturnType<typeof getV11InfraGpuModels>>,
  TError = ErrorType<unknown>,
>(
  params?: MaybeRef<GetV11InfraGpuModelsParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV11InfraGpuModels>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV11InfraGpuModelsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV11InfraGpuModels>>> = ({ signal }) =>
    getV11InfraGpuModels(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV11InfraGpuModels>>,
    TError,
    TData
  >;
};

export type GetV11InfraGpuModelsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV11InfraGpuModels>>
>;
export type GetV11InfraGpuModelsQueryError = ErrorType<unknown>;

/**
 * @summary GPU 모델명 목록
 */

export function useGetV11InfraGpuModels<
  TData = Awaited<ReturnType<typeof getV11InfraGpuModels>>,
  TError = ErrorType<unknown>,
>(
  params?: MaybeRef<GetV11InfraGpuModelsParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV11InfraGpuModels>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV11InfraGpuModelsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * 클러스터에서 GPU 를 쓰는 네임스페이스만 조회. 지표를 계산하지 않는 선택지 목록용
 * @summary GPU 네임스페이스 목록
 */
export const getV11InfraGpuNamespaces = (
  params: MaybeRef<GetV11InfraGpuNamespacesParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<ApiResponseInfraGpuNamespaceResponse>(
    { url: `/api/v11/infra/gpu/namespaces`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getGetV11InfraGpuNamespacesQueryKey = (
  params?: MaybeRef<GetV11InfraGpuNamespacesParams>,
) => {
  return ['api', 'v11', 'infra', 'gpu', 'namespaces', ...(params ? [params] : [])] as const;
};

export const getGetV11InfraGpuNamespacesQueryOptions = <
  TData = Awaited<ReturnType<typeof getV11InfraGpuNamespaces>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV11InfraGpuNamespacesParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV11InfraGpuNamespaces>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV11InfraGpuNamespacesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV11InfraGpuNamespaces>>> = ({
    signal,
  }) => getV11InfraGpuNamespaces(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV11InfraGpuNamespaces>>,
    TError,
    TData
  >;
};

export type GetV11InfraGpuNamespacesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV11InfraGpuNamespaces>>
>;
export type GetV11InfraGpuNamespacesQueryError = ErrorType<unknown>;

/**
 * @summary GPU 네임스페이스 목록
 */

export function useGetV11InfraGpuNamespaces<
  TData = Awaited<ReturnType<typeof getV11InfraGpuNamespaces>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV11InfraGpuNamespacesParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV11InfraGpuNamespaces>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV11InfraGpuNamespacesQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}
/**
 * GPU에서 실행 중인 프로세스 목록 조회
 * @summary GPU 프로세스 목록
 */
export const getV11InfraGpuProcess = (
  params: MaybeRef<GetV11InfraGpuProcessParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<ApiResponseInfraGpuProcessResponse>(
    { url: `/api/v11/infra/gpu/process`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getGetV11InfraGpuProcessQueryKey = (
  params?: MaybeRef<GetV11InfraGpuProcessParams>,
) => {
  return ['api', 'v11', 'infra', 'gpu', 'process', ...(params ? [params] : [])] as const;
};

export const getGetV11InfraGpuProcessQueryOptions = <
  TData = Awaited<ReturnType<typeof getV11InfraGpuProcess>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV11InfraGpuProcessParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV11InfraGpuProcess>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV11InfraGpuProcessQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV11InfraGpuProcess>>> = ({ signal }) =>
    getV11InfraGpuProcess(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV11InfraGpuProcess>>,
    TError,
    TData
  >;
};

export type GetV11InfraGpuProcessQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV11InfraGpuProcess>>
>;
export type GetV11InfraGpuProcessQueryError = ErrorType<unknown>;

/**
 * @summary GPU 프로세스 목록
 */

export function useGetV11InfraGpuProcess<
  TData = Awaited<ReturnType<typeof getV11InfraGpuProcess>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV11InfraGpuProcessParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV11InfraGpuProcess>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV11InfraGpuProcessQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary GPU 리소스 맵
 */
export const getV11InfraGpuResource = (
  params: MaybeRef<GetV11InfraGpuResourceParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<ApiResponseInfraGpuResourceMapResponse>(
    { url: `/api/v11/infra/gpu/resource`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getGetV11InfraGpuResourceQueryKey = (
  params?: MaybeRef<GetV11InfraGpuResourceParams>,
) => {
  return ['api', 'v11', 'infra', 'gpu', 'resource', ...(params ? [params] : [])] as const;
};

export const getGetV11InfraGpuResourceQueryOptions = <
  TData = Awaited<ReturnType<typeof getV11InfraGpuResource>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV11InfraGpuResourceParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV11InfraGpuResource>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV11InfraGpuResourceQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV11InfraGpuResource>>> = ({ signal }) =>
    getV11InfraGpuResource(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV11InfraGpuResource>>,
    TError,
    TData
  >;
};

export type GetV11InfraGpuResourceQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV11InfraGpuResource>>
>;
export type GetV11InfraGpuResourceQueryError = ErrorType<unknown>;

/**
 * @summary GPU 리소스 맵
 */

export function useGetV11InfraGpuResource<
  TData = Awaited<ReturnType<typeof getV11InfraGpuResource>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV11InfraGpuResourceParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV11InfraGpuResource>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV11InfraGpuResourceQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * GPU 리소스 현황 대상 필터용 호스트/노드 · GPU 디바이스 목록 조회
 * @summary GPU 대상 필터 목록
 */
export const getV11InfraGpuTargets = (
  params: MaybeRef<GetV11InfraGpuTargetsParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<ApiResponseInfraGpuTargetResponse>(
    { url: `/api/v11/infra/gpu/targets`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getGetV11InfraGpuTargetsQueryKey = (
  params?: MaybeRef<GetV11InfraGpuTargetsParams>,
) => {
  return ['api', 'v11', 'infra', 'gpu', 'targets', ...(params ? [params] : [])] as const;
};

export const getGetV11InfraGpuTargetsQueryOptions = <
  TData = Awaited<ReturnType<typeof getV11InfraGpuTargets>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV11InfraGpuTargetsParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV11InfraGpuTargets>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV11InfraGpuTargetsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV11InfraGpuTargets>>> = ({ signal }) =>
    getV11InfraGpuTargets(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV11InfraGpuTargets>>,
    TError,
    TData
  >;
};

export type GetV11InfraGpuTargetsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV11InfraGpuTargets>>
>;
export type GetV11InfraGpuTargetsQueryError = ErrorType<unknown>;

/**
 * @summary GPU 대상 필터 목록
 */

export function useGetV11InfraGpuTargets<
  TData = Awaited<ReturnType<typeof getV11InfraGpuTargets>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV11InfraGpuTargetsParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV11InfraGpuTargets>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV11InfraGpuTargetsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * 대상 리소스에 속한 모든 GPU의 상세 정보 조회
 * @summary GPU 상세 정보 (호스트/노드)
 */
export const getV11InfraGpuByTargetKindAndTargetId = (
  targetKind: MaybeRef<'GPU' | 'HOST' | 'NODE' | 'POD' | 'PROCESS'>,
  targetId: MaybeRef<string>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  targetKind = unref(targetKind);
  targetId = unref(targetId);

  return customAxiosInstance<ApiResponseInfraGpuByTargetResponse>(
    { url: `/api/v11/infra/gpu/${targetKind}/${targetId}`, method: 'GET', signal },
    options,
  );
};

export const getGetV11InfraGpuByTargetKindAndTargetIdQueryKey = (
  targetKind?: MaybeRef<'GPU' | 'HOST' | 'NODE' | 'POD' | 'PROCESS'>,
  targetId?: MaybeRef<string>,
) => {
  return ['api', 'v11', 'infra', 'gpu', targetKind, targetId] as const;
};

export const getGetV11InfraGpuByTargetKindAndTargetIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getV11InfraGpuByTargetKindAndTargetId>>,
  TError = ErrorType<unknown>,
>(
  targetKind: MaybeRef<'GPU' | 'HOST' | 'NODE' | 'POD' | 'PROCESS'>,
  targetId: MaybeRef<string>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV11InfraGpuByTargetKindAndTargetId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV11InfraGpuByTargetKindAndTargetIdQueryKey(targetKind, targetId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV11InfraGpuByTargetKindAndTargetId>>
  > = ({ signal }) =>
    getV11InfraGpuByTargetKindAndTargetId(targetKind, targetId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!(unref(targetKind) && unref(targetId))),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV11InfraGpuByTargetKindAndTargetId>>,
    TError,
    TData
  >;
};

export type GetV11InfraGpuByTargetKindAndTargetIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV11InfraGpuByTargetKindAndTargetId>>
>;
export type GetV11InfraGpuByTargetKindAndTargetIdQueryError = ErrorType<unknown>;

/**
 * @summary GPU 상세 정보 (호스트/노드)
 */

export function useGetV11InfraGpuByTargetKindAndTargetId<
  TData = Awaited<ReturnType<typeof getV11InfraGpuByTargetKindAndTargetId>>,
  TError = ErrorType<unknown>,
>(
  targetKind: MaybeRef<'GPU' | 'HOST' | 'NODE' | 'POD' | 'PROCESS'>,
  targetId: MaybeRef<string>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV11InfraGpuByTargetKindAndTargetId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV11InfraGpuByTargetKindAndTargetIdQueryOptions(
    targetKind,
    targetId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}
